import Button from "src/components/MyButton/Button"
import { StyleTabsCustom } from "src/components/TabsCustom/styled"
import TabsCustom from "src/components/TabsCustom"
import ListPurchase from "./component/ListSale"
import { useState } from "react"
import { WrapperStyle } from "../../HumanResource/styled"
import { ToolBarStyle } from "../../HumanResource/Work/Task/styled"
import OrderService from "src/services/OrderService"
import { message } from "antd"

const Index = props => {
  const [filter, setFilter] = useState({})
  const [keywordExcel, setKeywordExcel] = useState("")
  const [openModal, setOpenModal] = useState(false)
  const [modalMode, setModalMode] = useState("create")
  const [userData, setUserData] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const handleExportExcel = async () => {
    try {
      const response = await OrderService.exportReport({
        status: 4,
        ...filter,
        keyword: keywordExcel,
        order_export_status: 3,
      })

      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)

        // Tạo ngày giờ để thêm vào tên file
        const now = new Date()
        const pad = n => n.toString().padStart(2, "0")
        const dateStr = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
          now.getDate(),
        )}_${pad(now.getHours())}${pad(now.getMinutes())}`
        const link = document.createElement("a")
        link.href = url
        link.setAttribute(
          "download",
          `Danh_sach_bao_cao_phan_ban_${dateStr}.xlsx`,
        )
        document.body.appendChild(link)
        link.click()

        link.remove()
        window.URL.revokeObjectURL(url)
      } else {
        message.error("Không có dữ liệu để xuất Excel.")
      }
    } catch (error) {
      console.error("Lỗi khi xuất Excel:", error)
      message.error("Xuất Excel thất bại.")
    }
  }

  return (
    <>
      {" "}
      <div>
        <WrapperStyle>
          <ToolBarStyle>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 4,
                marginBottom: 20,
                flexWrap: "wrap",
                gap: 8,
              }}
              className="px-2 p-md-0"
            >
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#005F90",
                  margin: 0,
                }}
              >
                {" "}
                BÁO CÁO PHẦN BÁN
              </h3>
            </div>
            <div style={{ marginLeft: "auto" }}>
              <Button btnType="primary1" onClick={handleExportExcel}>
                Xuất Excel
              </Button>
            </div>
            <div className="right-side d-none d-md-flex"></div>
            <div style={{ width: "100%" }} className="px-2 p-md-0">
              <ListPurchase
                // type={Tabs[key].type}
                scroll={{ x: true }}
                // tabStatus={tabStatus}
                setParentFilter={setFilter}
                filter={filter}
                refresh={refresh}
                setRefresh={setRefresh}
                // permissions={permissions}
                setKeywordExcel={setKeywordExcel}
              />
            </div>
          </ToolBarStyle>
        </WrapperStyle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
            flexWrap: "wrap",
            gap: 12,
            position: "relative",
          }}
        ></div>
      </div>
    </>
  )
}
export default Index
